import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { TextAreaComponent } from './text-area.component';

@NgModule({
  imports: [CommonModule, ErrorTooltipModule, FormsModule],
  declarations: [TextAreaComponent],
  exports: [TextAreaComponent]
})
export class TextAreaModule {}
